import { render, staticRenderFns } from "./p_tech034.vue?vue&type=template&id=2752f4cb&scoped=true&"
import script from "./p_tech034.vue?vue&type=script&lang=js&"
export * from "./p_tech034.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2752f4cb",
  null
  
)

export default component.exports